import dayjs from 'dayjs'
import XLSX from 'xlsx-js-style' 
import { editDateForExcel } from '@/utils/excel'

export const ExportExcel = async (jsonData: any[]) => {

    const reportExcel = jsonData.map(x => {
        let n = {} as any
            n[`ชื่อโครงการ`] = x.projectNameTH
            n[`ยูนิต`] = x.unitCode
            n[`สถานะการขาย`] = x.salesStatus
            n[`วันโอนตามสัญญา`] = x.transferPmt1stDate == "" ? "" : editDateForExcel(x.transferPmt1stDate)
            n[`วันโอนจริง`] = x.activityDate == "" ? "" : editDateForExcel(x.activityDate)
            n[`เดือนที่คาดว่าจะโอน`] = x.expectTransferMonTH
            n[`สถานะการโอน`] = x.transferferStatusTH
            n[`เงื่อนไขเก็บงานหลังโอนกรรมสิทธิ์`] = x.flagRepairAfterTransfer
            n[`วันที่ PJ Plan พร้อมให้เข้าตรวจ #1`] = x.planPJDate1 == "" ? "" : editDateForExcel(x.planPJDate1)
            n[`วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #1`] = x.finishPJDate1 == "" ? "" : editDateForExcel(x.finishPJDate1)
            n[`วันที่ CR นัดลูกค้าได้ #1`] = x.planCRDate1 == "" ? "" : editDateForExcel(x.planCRDate1)
            n[`เวลาที่ CR นัดลูกค้าได้ #1`] = x.planCRTime1
            n[`วันที่ลูกค้าเข้าตรวจจริง #1`] = x.customerDate1 == "" ? "" : editDateForExcel(x.customerDate1)
            n[`สถานะการรับมอบ #1`] = x.inspectionDescription1
            n[`วันที่ PJ Plan พร้อมให้เข้าตรวจ #2`] = x.planPJDate2  == "" ? "" : editDateForExcel(x.planPJDate2)
            n[`วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #2`] = x.finishPJDate2  == "" ? "" : editDateForExcel(x.finishPJDate2)
            n[`วันที่ CR นัดลูกค้าได้ #2`] = x.planCRDate2  == "" ? "" : editDateForExcel(x.planCRDate2)
            n[`เวลาที่ CR นัดลูกค้าได้ #2`] = x.planCRTime2
            n[`วันที่ลูกค้าเข้าตรวจจริง #2`] = x.customerDate2 == "" ? "" : editDateForExcel(x.customerDate2)
            n[`สถานะการรับมอบ #2`] = x.inspectionDescription2
            n[`วันที่ PJ Plan พร้อมให้เข้าตรวจ #3`] = x.planPJDate3 == "" ? "" : editDateForExcel(x.planPJDate3)
            n[`วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #3`] = x.finishPJDate3 == "" ? "" : editDateForExcel(x.finishPJDate3)
            n[`วันที่ CR นัดลูกค้าได้ #3`] = x.planCRDate3 == "" ? "" : editDateForExcel(x.planCRDate3)
            n[`เวลาที่ CR นัดลูกค้าได้ #3`] = x.planCRTime3
            n[`วันที่ลูกค้าเข้าตรวจจริง #3`] = x.customerDate3 == "" ? "" : editDateForExcel(x.customerDate3)
            n[`สถานะการรับมอบ #3`] = x.inspectionDescription3
            n[`วันที่ PJ Plan พร้อมให้เข้าตรวจ #4`] = x.planPJDate4 == "" ? "" : editDateForExcel(x.planPJDate4)
            n[`วันที่ PJ เก็บงานเสร็จพร้อมตรวจ #4`] = x.finishPJDate4 == "" ? "" : editDateForExcel(x.finishPJDate4)
            n[`วันที่ CR นัดลูกค้าได้ #4`] = x.planCRDate4 == "" ? "" : editDateForExcel(x.planCRDate4)
            n[`เวลาที่ CR นัดลูกค้าได้ #4`] = x.planCRTime4
            n[`วันที่ลูกค้าเข้าตรวจจริง #4`] = x.customerDate4 == "" ? "" : editDateForExcel(x.customerDate4)
            n[`สถานะการรับมอบ #4`] = x.inspectionDescription4
            n[`จำนวนวัน Delay การนัดตรวจ (ครั้งที่ 2, 3, 4)`] = x.delayMax
            n[`จำนวนวัน Delay งานแก้ไข`] = x.delayEdit
            n[`วันที่ออกจดหมายนัดตรวจ (PL)`] = x.checkLetterPrintDate == "" ? "" : editDateForExcel(x.checkLetterPrintDate)
            n[`วันที่ออกจดหมายนัดโอน (PL)`] = x.transferLetterPrintDate == "" ? "" : editDateForExcel(x.transferLetterPrintDate)
            n[`พนักงานขาย`] = x.salesName
            n[`CR ที่รับผิดชอบ`] = x.crName
            return n
    })

    const dataWS = XLSX.utils.json_to_sheet(reportExcel,  {dateNF: "dd/MM/yyyy" })
        const wb = XLSX.utils.book_new()
            

        let nCols = 1
        for (const key in reportExcel) {
            nCols++
            dataWS[`D${nCols}`].t = "n"
            dataWS[`D${nCols}`].z = "dd/MM/yyyy"
            dataWS[`E${nCols}`].t = "n"
            dataWS[`E${nCols}`].z = "dd/MM/yyyy"
            dataWS[`I${nCols}`].t = "n"
            dataWS[`I${nCols}`].z = "dd/MM/yyyy"
            dataWS[`J${nCols}`].t = "n"
            dataWS[`J${nCols}`].z = "dd/MM/yyyy"
            dataWS[`K${nCols}`].t = "n"
            dataWS[`K${nCols}`].z = "dd/MM/yyyy"
            dataWS[`M${nCols}`].t = "n"
            dataWS[`M${nCols}`].z = "dd/MM/yyyy"
            dataWS[`O${nCols}`].t = "n"
            dataWS[`O${nCols}`].z = "dd/MM/yyyy"
            dataWS[`P${nCols}`].t = "n"
            dataWS[`P${nCols}`].z = "dd/MM/yyyy"
            dataWS[`Q${nCols}`].t = "n"
            dataWS[`Q${nCols}`].z = "dd/MM/yyyy"
            dataWS[`S${nCols}`].t = "n"
            dataWS[`S${nCols}`].z = "dd/MM/yyyy"
            dataWS[`U${nCols}`].t = "n"
            dataWS[`U${nCols}`].z = "dd/MM/yyyy"
            dataWS[`V${nCols}`].t = "n"
            dataWS[`V${nCols}`].z = "dd/MM/yyyy"
            dataWS[`W${nCols}`].t = "n"
            dataWS[`W${nCols}`].z = "dd/MM/yyyy"
            dataWS[`Y${nCols}`].t = "n"
            dataWS[`Y${nCols}`].z = "dd/MM/yyyy"
            dataWS[`AA${nCols}`].t = "n"
            dataWS[`AA${nCols}`].z = "dd/MM/yyyy"
            dataWS[`AB${nCols}`].t = "n"
            dataWS[`AB${nCols}`].z = "dd/MM/yyyy"
            dataWS[`AC${nCols}`].t = "n"
            dataWS[`AC${nCols}`].z = "dd/MM/yyyy"
            dataWS[`AE${nCols}`].t = "n"
            dataWS[`AE${nCols}`].z = "dd/MM/yyyy"
            dataWS[`AI${nCols}`].t = "n"
            dataWS[`AI${nCols}`].z = "dd/MM/yyyy"
            dataWS[`AJ${nCols}`].t = "n"
            dataWS[`AJ${nCols}`].z = "dd/MM/yyyy"
        }
                
        let wscols = [ 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 },
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 },
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 },
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 },
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:20 }, 
            { wch:40 }, 
            { wch:40 }
        ];
        dataWS['!cols'] = wscols

        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb,`Trackingtransfer-Report-${splitProjectCode(jsonData[0].unitCode)}-${dayjs().format("DD-MM-YYYY")}.xlsx`)
}

const splitProjectCode = (data: string) => {
    if (data != "") {
        const [ project, unit ] = data.split("-")
        return `${project}`
    }
    return ""
}